import createSlice from './helpers/createSlice'

// Types & Interfaces
export interface REIT {
  id: number
  name: string
}

// Slice Name
export const sliceName = 'reits'

// Abstract Slice Instance
const reitsSlice = createSlice<REIT[]>(sliceName)

// Initial state
export const initialState = reitsSlice.initialState

// Slice Selectors Hooks
export const useREITs = reitsSlice.useSlice

// Slice Actions Hooks
export const useLoadREITs = reitsSlice.useLoadSlicePayload

export const useDismissREITsHTTPErrors = reitsSlice.useDismissHTTPErrors

// Slice reducer
export default reitsSlice.reducer
